const authHeader = (isfile) => {
    let user;
    if (typeof window !== 'undefined') {
        user = JSON.parse(localStorage.getItem('user'));
    }
    let account;
    if (typeof window !== 'undefined') {
        account = JSON.parse(localStorage.getItem('account'));
    }

    const token = user ? user.token : null;
    const accountToken = account ? account.token : null;

    if (accountToken || token) {
        if (isfile) {
            return {
                Authorization: `Bearer ${accountToken},Bearer ${token}`,
                Accept: 'application/json',
            };
        } else {
            return {
                Authorization: `Bearer ${accountToken},Bearer ${token}`,
                Accept: 'application/json',
                'Content-Type': 'application/json',
            };
        }
    }

    if (isfile) {
        return {
            Accept: 'application/json',
        };
    } else {
        return {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        };
    }
};

const setHeader = (method = 'GET', isfile = false) => {
    if (method === 'GET') {
        return {
            method: method,
            headers: authHeader(),
        };
    } else {
        return {
            method: method,
            // credentials: "include",
            headers: authHeader(isfile),
        };
    }
};

const API_HOST = process.env.NEXT_PUBLIC_HOSTNAME;

export const get = async (target) => {
    const options = setHeader();

    const response = await fetch(API_HOST + target, options);
    const result = await response.json();

    return result;
};

export const put = async (target, datas) => {
    const options = setHeader('PUT');
    options.body = JSON.stringify(datas);
    const response = await fetch(API_HOST + target, options);
    const jsonData = await response.json();
    return jsonData;
};

export const post = async (target, data) => {
    const options = setHeader('POST');

    options.body = JSON.stringify(data);
    const response = await fetch(API_HOST + target, options);
    const result = await response.json();
    return result;
};

export const destroy = async (target, datas) => {
    const options = setHeader('DELETE');
    options.body = JSON.stringify(datas);
    const response = await fetch(API_HOST + target, options);
    const jsonData = await response.json();
    return jsonData;
};

export const upload = async (target, data) => {
    const options = setHeader('POST', true);
    options.body = data;
    const response = await fetch(API_HOST + target, options);
    const jsonData = await response.json();
    return jsonData;
};

export const uploadWithProgress = (target, data, onProgress) => {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        const headers = setHeader('POST', true).headers || {};

        xhr.upload.addEventListener('progress', (e) => {
            if (e.lengthComputable && onProgress) {
                onProgress(Math.round((e.loaded / e.total) * 100));
            }
        });

        xhr.addEventListener('load', () => {
            try {
                resolve(JSON.parse(xhr.responseText));
            } catch {
                reject(new Error('JSON parse error'));
            }
        });

        xhr.addEventListener('error', () => reject(new Error('Upload failed')));
        xhr.addEventListener('abort', () => reject(new Error('Upload aborted')));

        xhr.open('POST', API_HOST + target);
        Object.entries(headers).forEach(([k, v]) => xhr.setRequestHeader(k, v));
        xhr.send(data);
    });
};

export const uploadPut = async (target, data) => {
    const options = setHeader('PUT', true);
    options.body = data;
    const response = await fetch(API_HOST + target, options);
    const jsonData = await response.json();
    return jsonData;
};

export const downloadFile = async (target, filename) => {
    const options = setHeader('GET', true);
    const response = await fetch(API_HOST + target, options);
    if (!response.ok) return { error: 'Татах боломжгүй' };
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || 'download';
    a.click();
    URL.revokeObjectURL(url);
    return { status: 'success' };
};

export const getBlob = async (target) => {
    const options = setHeader('GET', true);
    const response = await fetch(API_HOST + target, options);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const blob = await response.blob();
    return URL.createObjectURL(blob);
};
